import { createAsyncAction, createAction } from 'typesafe-actions';
import {
  BrandingFile, BrandingFileDto, DashboardBranding, DashboardBrandingDto, FhqBranding, FhqBrandingDto,
} from '@rootCommon/types/branding';
import { IdType } from '@rootCommon/types/common';

// Branding Files
export const fetchBrandingFiles = createAsyncAction(
  'FETCH_BRANDING_FILES_REQUEST',
  'FETCH_BRANDING_FILES_SUCCESS',
  'FETCH_BRANDING_FILES_FAILURE',
)<void, BrandingFile[], Error>();

export const createBrandingFile = createAsyncAction(
  'CREATE_BRANDING_FILE_REQUEST',
  'CREATE_BRANDING_FILE_SUCCESS',
  'CREATE_BRANDING_FILE_FAILURE',
)<BrandingFileDto, BrandingFile, Error>();

export const deleteBrandingFile = createAsyncAction(
  'DELETE_BRANDING_FILE_REQUEST',
  'DELETE_BRANDING_FILE_SUCCESS',
  'DELETE_BRANDING_FILE_FAILURE',
)<IdType, IdType, Error>();

// Dashboard Branding
export const fetchDashboardBranding = createAsyncAction(
  'FETCH_DASHBOARD_BRANDING_REQUEST',
  'FETCH_DASHBOARD_BRANDING_SUCCESS',
  'FETCH_DASHBOARD_BRANDING_FAILURE',
)<void, DashboardBranding, Error>();

export const updateDashboardBranding = createAsyncAction(
  'UPDATE_DASHBOARD_BRANDING_REQUEST',
  'UPDATE_DASHBOARD_BRANDING_SUCCESS',
  'UPDATE_DASHBOARD_BRANDING_FAILURE',
)<{ id: IdType; data: DashboardBrandingDto }, DashboardBranding, Error>();

export const deleteDashboardBranding = createAction('DELETE_DASHBOARD_BRANDING')<void>();

// Fhq Branding
export const fetchFhqBranding = createAsyncAction(
  'FETCH_FHQ_BRANDING_REQUEST',
  'FETCH_FHQ_BRANDING_SUCCESS',
  'FETCH_FHQ_BRANDING_FAILURE',
)<IdType, FhqBranding, Error>(); // siteId

export const updateFhqBranding = createAsyncAction(
  'UPDATE_FHQ_BRANDING_REQUEST',
  'UPDATE_FHQ_BRANDING_SUCCESS',
  'UPDATE_FHQ_BRANDING_FAILURE',
)<{ id: IdType; data: FhqBrandingDto }, FhqBranding, Error>();

export const deleteFhqBranding = createAction('DELETE_FHQ_BRANDING')<IdType>();
